export default {"src":"/_next/static/media/footer_locicon.f938b310.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};